import { CARD_DEFAULT_TEMPLATE_NAME } from 'common/constants';
import { CardFacadeBase } from 'common/utils/facades/card-facade-base';
import { defaultTemplate } from 'common/utils/facades/templates/default-template';

class PollFacade extends CardFacadeBase {
	static template = {
		[CARD_DEFAULT_TEMPLATE_NAME]: defaultTemplate,
	};
}

export { PollFacade };
